import { Component, OnInit, ViewEncapsulation, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { StepsModule } from 'primeng/steps';
import { MenuItem } from 'primeng/api';
import { Message, SelectItem, ConfirmationService } from 'primeng/primeng';
import { Router } from '@angular/router';
import { ApiService } from '../api.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { SimplePdfViewerComponent, SimplePDFBookmark } from 'simple-pdf-viewer';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { StoreService } from '../store.service';
import * as moment from 'moment';
import { element } from 'protractor';
import { TabViewModule } from 'primeng/tabview';
import Swal from 'sweetalert2';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { DropdownModule } from 'primeng/dropdown';
import { Alert } from 'selenium-webdriver';


@Component({
  selector: 'app-doc-review',
  templateUrl: './doc-review.component.html',
  styleUrls: ['./doc-review.component.css'],
  encapsulation: ViewEncapsulation.None,
  providers: [ApiService, ConfirmationService]
})
export class DocReviewComponent implements OnInit {

  msgs: Message[] = [];
  steps: MenuItem[];
  activeIndex: number = 2;
  qboDocumentselect: any;
  qboDocumentMain: any = [];

  qboDocumentToDelete: any = [];
  qboDocumentLineToDelete: any = [];
  rowGroupMetadata: any;
  allDeleteSelected = false;  // header delete all checkbox
  allApproveSelected = false; 
  
  deleteSelectedAllLine=false; // line item delete all checkbox
  qboTax: SelectItem[] = [];
  qboVendor: SelectItem[] = [];
  qboVendorTemp: any = [];
  qboTermsTemp: any = [];
  qboTerms: SelectItem[] = [];
  results: string[];
  tampqboTax: any[];
  ScanPdfPath: any;
  totalDocToScan: any;
  documentScanIndex: any;
  loadingMessage: any;
  connectCompanyMessage: string = "";
  isViewerHidden: any = false;
  display: boolean = false;
  dialogEditVisible: boolean = false;
  saveClicked: boolean = false;
  editDocumentID: any = 0;
  editTotal: any = 0;
  editRefNumber: string = "";
  editSupplierName: string = "";
  isJob: boolean = false;
  isClass: boolean = false;
  isAccountDetail: boolean = true;
  isItemDetail: boolean = false;

  documentID: any = 0;
  qboDocumentLinesEdit: any = [];
  documentVendor: "";
  termsListID:"";
  headerCustomerJobName: any = "";
  billingAddress = "";
  reportViaTPAR = false;
  billNumber = "";
  invoiceNumber = "";
  invoiceDate: Date;
  documentMemo = "";
  dueDate: Date;
  dueDate_New: Date;
  scanBlobUrl = "";
  editSubTotal: any = 0;
  editGstTotal: any = 0;
  currantDate: Date;

  SelectedCust: any;
  qboaccount: SelectItem[] = [];
  qboaccountsTemp: any = [];

  qboitems: SelectItem[] = [];
  qboitemsTemp: any = [];

  qboCustomers: SelectItem[] = [];
  qboCustomerTemp: any = [];

  qboClass: SelectItem[] = [];
  qboClassTemp: any = [];

  filteredCustomer: any[];
  filteredAccount: any[];

  @ViewChild(SimplePdfViewerComponent) private pdfViewer: SimplePdfViewerComponent;
  bookmarks: SimplePDFBookmark[] = [];

  @Output() childEvent = new EventEmitter();
  index: number = 0;
  pdfContent: any;
  @ViewChild('pdfview') pdfview: ElementRef;

  constructor(private router: Router, private api: ApiService, private http: HttpClient,
    private spinner: NgxSpinnerService, private ss: StoreService,
    private confirmationService: ConfirmationService) {

    var rahSetting = this.ss.fetchAccountRahMaster();

  }

  ngOnInit() {
    this.ss.storePageName('/docreview');

    this.steps = [
      {
        label: 'Map Supplier Default Account',
        command: (event: any) => {
          this.ss.storePageName('/mapaccount');
          this.activeIndex = 0;
          this.router.navigateByUrl('/mapaccount');
        }
      },
      {
        label: 'Upload Document',
        command: (event: any) => {
          this.ss.storePageName('/docupload');
          this.activeIndex = 1;
          this.router.navigateByUrl('/docupload');
        }
      },
      {
        label: 'Review and Approve',
        command: (event: any) => {
          this.ss.storePageName('/docreview');
          this.activeIndex = 2;
          this.router.navigateByUrl('/docreview');
        }
      },
      {
        label: 'Post To Accounting System',
        command: (event: any) => {
          this.ss.storePageName('/docpost');
          this.activeIndex = 3;
          this.router.navigateByUrl('/docpost');
        }
      }
    ];

    this.validateConnectCompany();
    this.GetQboDocumentToApprove_New();
    this.bindTax();
    this.GetQboTerms();
  }


  handleClose(event) {

    // this.index = event.index;

    // if (this.index == 1) {
    //   this.initLoad();
    // }
  }


  initLoad() {

    this.spinner.show();
    this.loadingMessage = "Loading...";
    this.validateConnectCompany();
    this.bindCustomers();

    this.getClass();
    this.bindVendors();
    this.bindAccount();
    this.bindItem();
 
  }

  bindTax() {

    this.tampqboTax = this.ss.fetchQboSalesTax();
    console.log('this.tampqboTax ');
    console.log(this.tampqboTax );
    if(this.tampqboTax == null) return;
    this.qboTax.push({ label: '', value: '' });

    this.tampqboTax .forEach(element => {
      this.qboTax.push({ label: element.Name, value: element.Name });
    });
  }

  //#region  header

  refresh() {
    this.GetQboDocumentToApprove_New();
  }

  GetQboDocumentToApprove_New() {
    this.loadingMessage = "Loading...";
    this.spinner.show();
    this.api.get('Scan/GetQboDocumentToApprove_New', '').subscribe(
      (res: {}) => this.sucessDocumentToScan(res),
      error => this.failedDocumentToScan(<any>error));

  }

  sucessDocumentToScan(resp: any) {
    this.spinner.hide();
    this.qboDocumentMain = resp.Data;
  }

  failedDocumentToScan(resp: any) {
    this.spinner.hide();

  }

  openDocument1(document: File) {

    const fileReader: FileReader = new FileReader();
    fileReader.onload = () => {
    };
    fileReader.readAsArrayBuffer(document);

  }

  viewPdf(value: any) {

    this.api.get('Scan/GetQboDocumentFilePath?qboDocumentID=', value.DocumentID).subscribe(
      (res: {}) => this.sucessDocumentFilePath(res),
      error => this.failedDocumentFile(<any>error));

  }


  sucessDocumentFilePath(resp: any) {
    console.log('this.api.apiPreBaseUrl + resp');
    console.log(this.api.apiPreBaseUrl + resp);

    const win = window.open(this.api.apiPreBaseUrl + resp, 'View Pdf', 'width=800,height=700');
    win.focus();
    console.log('this.api.apiPreBaseUrl + resp');
    console.log(this.api.apiPreBaseUrl + resp);
  }


  showPdf(value: any) {
    let headers = new HttpHeaders();
    headers = headers.set('Accept', 'application/pdf');

    this.http.get(this.api.apiBaseUrl + 'Scan/GetQbDocumentFile?qboDocumentID=' + value.DocumentID, { headers: headers, responseType: 'blob' }).subscribe(
      (res: {}) => this.sucessDocumentFile(res),
      error => this.failedDocumentFile(<any>error));
  }

  sucessDocumentFile(resp: any) {
    this.display = true;
    console.log('Array byte')
    console.log(resp)

    var file = new Blob([resp], { type: 'application/pdf' });
    var fileURL = URL.createObjectURL(file);
    const win = window.open(fileURL , 'View Pdf', 'width=800,height=700');

     win.focus();


   

  }


  deleteRecord(record: any) {


    this.confirmationService.confirm({
      message: 'Are you sure want to remove this record ?',
      accept: () => {
        this.loadingMessage = "Delete to Record..";
        this.spinner.show();

        this.api.post('Rah/DeleteQboDocument', { 'DocumentID': record.DocumentID, 'Deleted': true }).subscribe(
          (res1: {}) => this.successDeleteRecord(res1),
          error => this.failedDeleteRecord(<any>error));
      },
      reject: () => {

      }
    });

  }



  successDeleteRecord(res: any) {
    this.spinner.hide();
    if (res.StatusCode == 0) {
      this.GetQboDocumentToApprove_New();
    } else {
      this.allDeleteSelected = false;
    }

  }



  failedDocumentFile(resp: any) {

  }

  getUniqueValues(key) {
    var result = new Set();
    this.qboDocumentMain.forEach(function (item) {
      if (item.hasOwnProperty(key)) {
        result.add(item[key]);
      }
    });
    return result;
  }

  onChangeDeleteAllHeader(event: any) {

    if (event.target.checked == true) {
      this.allDeleteSelected = true;

      var distinctDoc = this.getUniqueValues("DocumentID");
      distinctDoc.forEach(element => {
        var qboDocument = this.qboDocumentMain.filter(xx => xx.DocumentID == element)
        qboDocument[0].Deleted = true;
        this.qboDocumentToDelete.push(qboDocument[0]);
      });
    }
    else {
      this.allDeleteSelected = false;
      var distinctDoc = this.getUniqueValues("DocumentID");
      distinctDoc.forEach(element => {
        var qboDocument = this.qboDocumentMain.filter(xx => xx.DocumentID == element)
        qboDocument[0].Deleted = false;
      });
      if (this.qboDocumentToDelete.length > 0)
        this.qboDocumentToDelete.splice(0, this.qboDocumentToDelete.length);
    }
  }

  onCheckBoxChangeDeleteAllLine(event: any) {

    console.log("onCheckBoxChangeDeleteAllLine:"+event.target.checked);
    if (event.target.checked == true) {
      this.deleteSelectedAllLine = true;

      this.qboDocumentLinesEdit.forEach(element => {
        element.Deleted = true;
        this.qboDocumentLineToDelete.push(element);
      });
    }
    else {
      this.deleteSelectedAllLine = false;
      this.qboDocumentLinesEdit.forEach(element => {
        element.Deleted = false;
      });
      if (this.qboDocumentLineToDelete.length > 0)
        this.qboDocumentLineToDelete.splice(0, this.qboDocumentLineToDelete.length);
    }
  }

  onDeleteClicked() {
    this.msgs = [];

    if (this.qboDocumentToDelete.length > 0) {
      if (confirm("Are you sure want to remove this document ?")) {
        this.api.post('Rah/DeleteMultipleQboDocument', this.qboDocumentToDelete).subscribe(
          (res1: {}) => this.successDeleteRecord(res1),
          error => this.failedDeleteRecord(<any>error));
      }
    }
    else {
      this.msgs.push({ severity: 'Info', summary: 'Please select document to delete', detail: 'Mandatory Field' });

      return;
    }
  }

  failedDeleteRecord(res: any) {
    console.log("InDelete");
    this.allDeleteSelected = false;
    this.spinner.hide();
  }

  onChangeDelete(event: any, hdr: any) {
    this.msgs = [];
    var qboDocument = this.qboDocumentMain.filter(xx => xx.DocumentID == hdr.DocumentID);
    qboDocument[0].Deleted = event.target.checked;

    if (event.target.checked) {
      this.qboDocumentToDelete.push(qboDocument[0]);
    }
    else {
      if (this.qboDocumentToDelete.length > 0) {
        const index: number = this.qboDocumentMain.indexOf(qboDocument);
        console.log(index);
        this.qboDocumentToDelete.splice(index, 1);
      }
    }


    var distinctDoc = this.getUniqueValues("DocumentID");
    console.log(distinctDoc.size + " " + this.qboDocumentToDelete.length);
    if (distinctDoc.size == this.qboDocumentToDelete.length && event.target.checked == true) {
      this.allDeleteSelected = true;
    }
    else {
      this.allDeleteSelected = false;
    }

  }

  onDeleteCheckBoxClick(event: any, hdr: any) {
    
    this.msgs = [];
    var qboDocument = this.qboDocumentLinesEdit.filter(xx => xx.DocumentID == hdr.DocumentID);
    qboDocument.Deleted = event.target.checked;

    if (event.target.checked) {
      this.qboDocumentLineToDelete.push(qboDocument);
    }
    else {
      if (this.qboDocumentLineToDelete.length > 0) {
        const index: number = this.qboDocumentLinesEdit.indexOf(qboDocument);
        console.log(index);
        this.qboDocumentLineToDelete.splice(index, 1);
      }
    }

    if ( this.qboDocumentLineToDelete.length== this.qboDocumentLinesEdit.length && event.target.checked == true) {
      this.deleteSelectedAllLine = true;
    }
    else {
      this.deleteSelectedAllLine = false;
    }

  }


  onChangeApprove(event: any, hdr: any) {
    this.msgs = [];

    this.getUpdatedDocument1(hdr.DocumentID, hdr, event);

  }

  getUpdatedDocument1(value: any, hdr: any, event: any) {

    this.spinner.show();
      
    this.api.get('Scan/GetUpdatedDocument?DocumentID=', value).subscribe(
      (res: {}) => this.successGetDocument1(res, hdr, event),
      error => this.failedtoGetDocument(<any>error));

  }

  successGetDocument1(resp: any, hdr: any, event: any) {

    this.spinner.hide();

    if (resp.Data.find(xx => xx.QboCustListID == "" || xx.QboCustListID == null) != null) {
      this.msgs.push({ severity: 'error', summary: 'Customer is a required field', detail: 'Mandatory Field' });
      event.target.checked = false;
      return;
    }

    console.log('this.isItemDetail')
    console.log(this.isItemDetail)
    console.log(resp.Data)

    if (this.isItemDetail) {
      if (resp.Data.find(xx => xx.QboItemListID == null || xx.QboItemListID == "") != null) {
        this.msgs.push({ severity: 'error', summary: 'Item is a required field', detail: 'Mandatory Field' });
        event.target.checked = false;
        return;
      }
    }
    else {
      if (resp.Data.find(xx => xx.QboAccountListID == null || xx.QboAccountListID == "") != null) {
        this.msgs.push({ severity: 'error', summary: 'Account is a required field', detail: 'Mandatory Field' });
        event.target.checked = false;
        return;
      }
    }

    console.log('hdr.SelectToBill')
    console.log(hdr.SelectToBill = true)

    hdr.SelectToBill = true;
    this.api.post('Qbo/ApproveRahDocument', hdr).subscribe(
      (res1: {}) => this.successApproveDoc(res1),
      error => this.failedApproveDoc(<any>error, hdr));

  }




  onChangeApproveAll(event: any) {
    this.msgs = [];
    let isOK = false;
    var distinctDoc = this.getUniqueValues("DocumentID");
    console.log('event.target.checked');
    console.log(event.target.checked);
    console.log(distinctDoc);

     console.log('this.qboDocumentMain');
     console.log(this.qboDocumentMain);

    this.allApproveSelected = event.target.checked;
    if (event.target.checked) {
      console.log('esp');
      
      distinctDoc.forEach(element => {

        var qboDocument = this.qboDocumentMain.filter(xx => xx.DocumentID == element);
        console.log('qboDocument Appr');
        console.log(qboDocument[0]);
        console.log(qboDocument);
        console.log('element');
        console.log(element);
        qboDocument[0].SelectToBill = true;
        this.getUpdatedDocument1(element, qboDocument[0], event);

      });

      this.allApproveSelected = false;
    }
    else {

      console.log('22');
      distinctDoc.forEach(element => {

        var lines = this.qboDocumentMain.filter(xx => xx.DocumentID == element);
        lines[0].SelectToBill = false;

        this.api.post('Qbo/ApproveRahDocument', lines[0]).subscribe(
          (res1: {}) => this.successApproveDoc(res1),
          error => this.failedApproveDoc(<any>error, lines[0]));

      });

    }
  }


  successApproveDoc(resp: any) {


    console.log(resp);

    var distinctDoc = this.getUniqueValues("DocumentID");
    var approveDoc = this.qboDocumentMain.filter(xx => xx.SelectToBill == true);
    if (approveDoc.length > 0) {
      if (approveDoc.length == distinctDoc.size) {
        this.allApproveSelected = true;
      }
      else
        this.allApproveSelected = false;
    } else {
      var approveDoc = this.qboDocumentMain.filter(xx => xx.SelectToBill == false);
      if (approveDoc.length > 0) {
        this.allApproveSelected = false;
      }
    }



  }
  failedApproveDoc(resp: any, hdr: any) {
    console.log("RESP " + resp);

    this.msgs = [];

    if (resp.indexOf("409"))
      this.msgs.push({ severity: 'Error', summary: 'Failed to approve', detail: 'Document with same InvoiceNumber already exist..' });
    else
      this.msgs.push({ severity: 'Error', summary: 'Failed to approve', detail: 'Failed to approve document.' });
    hdr.SelectToBill = false;
  }

  showHideViewer() {
    this.isViewerHidden = !this.isViewerHidden;
  }

  openEditScreen(record: any) {
    this.index = 1;


    this.initLoad();
    this.qboDocumentselect = record;
    this.GetUpdatedDocumentLine(record.DocumentID);
    this.documentID = record.DocumentID;
    this.documentVendor = record.QboCustListID;
    this.billingAddress = record.ShippingTo;
    this.billNumber = record.ScanABNNumber;
    this.invoiceNumber = record.ScanRefNumber;
    this.invoiceDate = record.ScanInvoiceDate;
    this.scanBlobUrl = record.ScanBlob_Url;
    this.documentMemo = record.Memo;
    this.termsListID = record.TermListID;
    this.documentID = record.DocumentID;
    this.dueDate_New = record.DueDate_New;
    
    //debugger
    if(record.DueDays == null || record.DueDays == undefined || record.DueDays <1)
    {
      if(record.ScanInvoiceDate!=null)
        {
          this.dueDate = this.addDays(30, new Date(record.ScanInvoiceDate));
        }else
        {
          this.dueDate = this.addDays(30, new Date());
        }

    }else{
      this.dueDate = record.DueDays;
    }
    console.log("record.DueDays1:"+this.dueDate);
  }

  GetUpdatedDocumentLine(value: any) {


    this.spinner.show();
    this.loadingMessage = "Processing...";
    this.api.get('Scan/GetUpdatedDocumentLine?DocumentID=', value).subscribe(
      (res: {}) => this.successGetDocumentLine(res),
      error => this.failedtoGetDocument(<any>error));

  }
  successGetDocumentLine(resp: any) {

    this.spinner.hide();
    console.log('this.qboDocumentLinesEdit')
    console.log(resp)
    this.qboDocumentLinesEdit = resp.Data;

    this.qboDocumentLinesEdit.forEach(element => {
      element.Deleted = false;
      var selectedTax = 0;
      if (element.ScanGST > 0) {
        selectedTax = (element.ScanGST * 100 / element.Scan_Total)
        element.ScanTax = Math.round(selectedTax * 10) / 10;

      }
      else
        element.ScanTax = 0;

    });

    if(this.qboDocumentLinesEdit == null || this.qboDocumentLinesEdit.length==0)
    {
      return;
    }
    this.documentVendor = this.qboDocumentLinesEdit[0].QboCustListID;
    // this.billingAddress = this.qboDocumentLinesEdit[0].ShippingTo;
    this.billNumber = this.qboDocumentLinesEdit[0].ScanABNNumber;
    this.invoiceNumber = this.qboDocumentLinesEdit[0].ScanRefNumber;
    this.invoiceDate = this.qboDocumentLinesEdit[0].ScanInvoiceDate;
    this.scanBlobUrl = this.qboDocumentLinesEdit[0].ScanBlob_Url;
    //this.documentMemo = this.qboDocumentLinesEdit[0].Memo;
    this.editTotal = this.qboDocumentLinesEdit[0].ScanInvoiceTotal;
    this.editGstTotal = this.qboDocumentLinesEdit[0].ScanTaxTotal;
    this.editSubTotal = this.qboDocumentLinesEdit[0].ScanSubTotal;

    this.syncHeaderCustomerJobFromLines();

    console.log("record.DueDays5:"+this.invoiceDate);
    var date = new Date(this.invoiceDate);
    
    console.log("record.DueDays5:"+date);
    var adddays = this.qboDocumentLinesEdit[0].DueDays>1?this.qboDocumentLinesEdit[0].DueDays:30
    console.log("record.DueDays5:"+adddays);
    //date.setDate(date.getDate() + adddays);

    this.dueDate = this.addDays(adddays, date);
    console.log("record.DueDays5:"+this.dueDate);
  }

   addDays(numOfDays: number, date = new Date()) : Date {
    date.setDate(date.getDate() + numOfDays);
  
    return date;
  }

  failedtoGetDocument(error: any) {
    this.spinner.hide();

    console.log(error);
  }


  //#endregion

  //#region  Line Detail

  validateConnectCompany() {

    this.api.get('Rah/GetByAccountID', '').subscribe(
      (res: {}) => this.sucessQboMaster(res),
      error => this.failedQboMaster(<any>error));

  }

  failedQboMaster(res: any) {
    this.spinner.hide();
  }

  sucessQboMaster(res: any) {
    // this.spinner.hide();
    if (res.StatusCode == 0) {

      var companyName = res.Data[0].CompanyName;
      if (companyName == '' || companyName == null) {
        this.connectCompanyMessage = "No company is connected, Connect a company from Switch Company menu";
      }
      this.isJob = res.Data[0].IsJob;
      this.isClass = res.Data[0].IsClass;
      this.isAccountDetail = res.Data[0].IsAccountDetail;
      this.isItemDetail = res.Data[0].IsItemDetail;
    }
  }

  GetQboTerms() {

    this.api.get('Rah/GetQboTerms', '').subscribe(
      (res: {}) => this.sucessTerms(res),
      error => this.failedTerms(<any>error));

  }

  failedTerms(res: any) {
    this.spinner.hide();
  }

  sucessTerms(res: any) {

    this.qboTermsTemp = res.Data;
    console.log('qboTermsTemp');
    console.log(this.qboTermsTemp );
    console.log(res);
    this.qboTerms.push({ label: '', value: '' });

    if (this.qboTermsTemp == null) return;

    this.qboTermsTemp.forEach(element => {
      this.qboTerms.push({ label: element.FullName, value: element.ListID });
    });
    
  }

  bindVendors() {

    this.qboVendorTemp = this.ss.fetchQboVendors();
    this.qboVendor.push({ label: '', value: '' });

    if (this.qboVendorTemp == null) return;

    this.qboVendorTemp.forEach(element => {
      this.qboVendor.push({ label: element.FullName, value: element.ListID });
    });
  }

  bindCustomers() {
    this.qboCustomerTemp = this.ss.fetchQboCustomers();
  }

  filterCustomer(event) {
    let filtered: any[] = [];
    let query = event.query;
    if (query == null || query.length >= 3) {
      for (let i = 0; i < this.qboCustomerTemp.length; i++) {
        let country = this.qboCustomerTemp[i];
        if (country.FullName.toLowerCase().includes(event.query.toLowerCase())) {
          filtered.push(country);
        }
      }
    }




    this.filteredCustomer = filtered;
  }


  onChangeCustomer(event: any, record: any) {

    const selected = this.getSelectedCustomer(event);
    if (!selected) return;

    //var acct = this.qboCustomerTemp.find(xx => xx.ListID == event);
    var acct = this.qboCustomerTemp.find(xx => xx.ListID == selected.ListID);
    if (!acct) return;
    record.QboJobID = acct.ListID;
    record.QboJobName = acct.FullName;

  }

  onChangeHeaderCustomerJob(event: any) {
    if (!this.isJob) return;
    const selected = this.getSelectedCustomer(event);
    if (!selected) return;

    if (selected.FullName != null) {
      this.headerCustomerJobName = selected.FullName;
    }

    if (this.qboDocumentLinesEdit == null) return;

    this.qboDocumentLinesEdit.forEach(line => {
      if (line == null) return;
      this.onChangeCustomer(selected, line);
    });
  }

  private getSelectedCustomer(event: any) {
    if (!event) return null;
    // PrimeNG AutoComplete can emit either the selected item directly, or a wrapper like { item: ... }
    const candidate = event.item ? event.item : event;
    if (candidate && candidate.ListID) return candidate;
    return null;
  }

  private syncHeaderCustomerJobFromLines() {
    if (!this.isJob) {
      this.headerCustomerJobName = "";
      return;
    }

    if (this.qboDocumentLinesEdit == null || this.qboDocumentLinesEdit.length === 0) {
      this.headerCustomerJobName = "";
      return;
    }

    const activeLines = this.qboDocumentLinesEdit.filter(x => x != null && x.Deleted !== true);
    if (activeLines.length === 0) {
      this.headerCustomerJobName = "";
      return;
    }

    const jobIds = activeLines
      .map(x => x.QboJobID)
      .filter(x => x != null && x !== "");

    const distinct = Array.from(new Set(jobIds));
    if (distinct.length !== 1) {
      this.headerCustomerJobName = "";
      return;
    }

    const first = activeLines.find(x => x.QboJobID === distinct[0]);
    this.headerCustomerJobName = first && first.QboJobName ? first.QboJobName : "";
  }

  bindAccount() {

    console.log('this.qboaccountsTemp')
    console.log(this.qboaccountsTemp)
    this.qboaccountsTemp = this.ss.fetchQboAccount();
    // this.qboaccount.push({ label: '', value: '' });
    // if (this.qboaccountsTemp == null) return;

    // this.qboaccountsTemp.forEach(element => {
    //   this.qboaccount.push({ label: element.FullName, value: element.ListID });
    // });
  }

  filterAccount(event) {

    let filtered: any[] = [];
    let query = event.query;
    if (query == null || query.length >= 3) {
      for (let i = 0; i < this.qboaccountsTemp.length; i++) {
        let country = this.qboaccountsTemp[i];
        // if (country.FullName.toLowerCase().indexOf(query.toLowerCase()) == 0) {
        //   filtered.push(country);
        // }
        if (country.FullName.toLowerCase().includes(event.query.toLowerCase())) {
          filtered.push(country);
        }
      }
    }

    this.filteredAccount = filtered;
  }

  onChangeAccount(event: any, record: any) {
    console.log(event.ListID);

    var acct = this.qboaccountsTemp.find(xx => xx.ListID == event.ListID);
    record.QboAccountName = acct.FullName;
    record.QboAccountListID = acct.ListID

  }


  bindItem() {
    this.qboitemsTemp = this.ss.fetchQboItem();
    this.qboitems.push({ label: '', value: '' });
    if (this.qboitemsTemp == null) return;

    this.qboitemsTemp.forEach(element => {
      this.qboitems.push({ label: element.FullName, value: element.ListID });
    });
  }
  getClass() {

    this.api.get('Rah/GetQboClass', '').subscribe(
      (res: {}) => this.success_getClass(res),
      error => this.failed_getClass(<any>error));

  }

  success_getClass(resp: any) {

    if (resp) {

      this.qboClassTemp = resp.Data;
      this.qboClass.push({ label: '', value: '' });

      if (this.qboClassTemp == null) return;

      this.qboClassTemp.forEach(element => {
        this.qboClass.push({ label: element.FullName, value: element.ListID });
      });

    }

  }


  failed_getClass(resp: any) {

  }


  onChangeBillNumber() {
    this.qboDocumentLinesEdit.forEach(element => {
      element.ScanABNNumber = this.billNumber;

    });
    this.billNumber = this.qboDocumentLinesEdit[0].ScanABNNumber;
  }
  onChangeInvoiceNumber() {
    this.qboDocumentLinesEdit.forEach(element => {
      element.ScanRefNumber = this.invoiceNumber;

    });
    this.invoiceNumber = this.qboDocumentLinesEdit[0].ScanRefNumber;
  }
  onChangeInvoiceDate(record: any) {

    this.qboDocumentLinesEdit.forEach(element => {
      element.ScanInvoiceDate = record

    });
    this.invoiceDate = this.qboDocumentLinesEdit[0].ScanInvoiceDate;
    var date = new Date(this.invoiceDate);
    date.setDate(date.getDate() + this.qboDocumentLinesEdit[0].DueDays>1?this.qboDocumentLinesEdit[0].DueDays:30);

    this.dueDate = date;
    console.log("record.DueDays2:"+this.dueDate);
  }
  
  onChangeDueDate(record: any) {

    console.log("record.DueDays222222222:"+record);

    this.qboDocumentselect.IsDueDateChange = 1;
    this.qboDocumentselect.DueDate_New = record;
    this.api.post('Rah/UpdateQboDocumentDueDate', this.qboDocumentselect).subscribe(
      (res1: {}) => this.succesUpdatedate(res1),
      error => this.failedUpdatedate(<any>error));
   
  }

  succesUpdatedate(res: any) {
    this.spinner.hide();
   
  }
  failedUpdatedate(res: any) {
    this.spinner.hide();
  }

  onChangeTerms(event: any) {

    var acct = this.qboTermsTemp.find(xx => xx.ListID == event.value);
    if(acct !=null)
    {
      // if(acct.StdDueDays>0)
      // {
 
        this.currantDate = new Date(this.qboDocumentselect.ScanInvoiceDate);
        console.log("onChangeTerms"+this.currantDate);
        console.log("acct.StdDueDays"+acct.StdDueDays);
        this.currantDate.setDate(this.currantDate.getDate() + acct.StdDueDays);

        console.log("acct.StdDueDays111"+this.currantDate);
        this.qboDocumentselect.DueDate_New = this.currantDate;
        this.dueDate_New = this.currantDate;
      // }
      // else{
      //   this.qboDocumentselect.DueDate_New = this.qboDocumentselect.ScanInvoiceDate;
      //   this.dueDate_New =  this.qboDocumentselect.ScanInvoiceDate;
      // }
      
    }

    this.qboDocumentselect.TermListID = event.value;
    this.qboDocumentselect.IsDueDateChange = 0;
    this.api.post('Rah/UpdateQboDocumentTermsList', this.qboDocumentselect).subscribe(
      (res1: {}) => this.succesUpdatedate(res1),
      error => this.failedUpdatedate(<any>error));

  }

  saveEditChanges() {
    this.msgs = [];
    this.qboDocumentLinesEdit.forEach(element => {
      element.Memo = this.documentMemo;
      element.DocumentID = this.documentID;
    });

    if (this.invoiceNumber == "") {
      this.msgs.push({ severity: 'error', summary: 'Supplier Invoice Number is a required field', detail: 'Mandatory Field' });
      return;
    }
    if (this.invoiceDate == null) {
      this.msgs.push({ severity: 'error', summary: 'Invoice Date is a required field', detail: 'Mandatory Field' });
      return;
    }
    if (this.documentVendor == "") {
      this.msgs.push({ severity: 'error', summary: 'Supplier is a required field', detail: 'Mandatory Field' });
      return;
    }
    var newRecord = this.qboDocumentLinesEdit.filter(a => a.DocumentLineID == 0);
    if (newRecord.length > 0 && (newRecord[0].ScanDescription == '' || newRecord[0].Scan_Quantity == 0 || newRecord[0].ScanUnit_Price == 0)) {
      Swal.fire('', 'Please fill all required data in newly added line', 'error');

      //alert("Please fill all required data in newly added line");
    }
    else {
      if (this.saveClicked == false) {
        this.saveClicked = true;
        this.spinner.show();
        this.loadingMessage = "Processing...";
        console.log(this.qboDocumentLinesEdit);

        this.api.post('Rah/SaveQboDocumentEditChanges', this.qboDocumentLinesEdit).subscribe(
          (res1: {}) => this.successSaveEditChanges(res1),
          error => this.failedSaveEditChanges(<any>error));
      }
    }

    var document = this.qboDocumentMain.find(xx => xx.DocumentID == this.qboDocumentselect.DocumentID);
    if (document != null) {
      document.Memo = this.documentMemo;
      document.ScanRefNumber = this.invoiceNumber;
      document.ScanInvoiceTotal = this.editTotal;
      document.QboCustListID = this.qboDocumentLinesEdit[0].QboCustListID;
      document.QboCustName = this.qboDocumentLinesEdit[0].QboCustName;
      document.ScanInvoiceDate = this.invoiceDate;
    }
  }

  successSaveEditChanges(res: any) {
    this.spinner.hide();
    this.saveClicked = false;
    if (res.StatusCode == 0) {
      Swal.fire('', 'Successfully updated invoice"', 'success');
      setTimeout(() => {

        // this.router.navigateByUrl("/docreview");
      }, 1000);

    }

    this.index = 0;
  }
  failedSaveEditChanges(res: any) {
    this.spinner.hide();
    this.saveClicked = false;

    console.log("Error");
  }




  onChangeItem(event: any, record: any) {
    var acct = this.qboitemsTemp.find(xx => xx.ListID == event.value);
    record.QboItemName = acct.FullName;
    record.QboItemListID = acct.ListID;
  }


  onChangeVendor(event: any) {
    var acct = this.qboVendorTemp.find(xx => xx.ListID == event.value);
    this.qboDocumentLinesEdit.forEach(element => {
      element.QboCustListID = acct.ListID;
      element.QboCustName = acct.FullName;
    });

  }

  onChangeClass(event: any, record: any) {
    var acct = this.qboClassTemp.find(xx => xx.ListID == event.value);
    record.QboClassListID = acct.ListID;
    record.QboClassName = acct.FullName;

  }
  CalculateTotal() {
    var total = 0;
    var gstTotal = 0;
    var subTotal = 0;
    this.qboDocumentLinesEdit.forEach(element => {
      total = total + element.Scan_Total;
      gstTotal = gstTotal + element.ScanGST;
      subTotal = subTotal + (element.Scan_Quantity * element.ScanUnit_Price);
      
    });

    this.qboDocumentLinesEdit.forEach(element => {
      element.ScanInvoiceTotal = total;
    });


    this.editTotal = total + gstTotal;
    this.editGstTotal = gstTotal;
    this.editSubTotal = subTotal;

  }

  onChangeTax(event: any, line: any) {

    console.log('onChangeTax');
    console.log(event);
    console.log(line);

    var acct = this.tampqboTax.find(xx => xx.Name == event.value);

    console.log('acct');
    console.log(acct);
     console.log(acct.TaxRate);
    line.TaxRate = acct.TaxRate;

    line.ScanGST = ((line.Scan_Quantity * line.ScanUnit_Price) * acct.TaxRate) / 100;

    this.CalculateTotal();
  }

  onChangeTaxAmount(record: any) {

    record.ScanGST = Math.round(record.ScanGST * 100) / 100;
    this.CalculateTotal();
  }

  onChangeQty(record: any) {
    // record.ISGSTTaxMod = false;
    record.Scan_Total = record.Scan_Quantity * record.ScanUnit_Price;
    record.ScanGST = ((record.Scan_Quantity * record.ScanUnit_Price) * record.TaxRate) / 100;
    this.CalculateTotal();
  }

  onChangePrice(record: any) {
    // record.ISGSTTaxMod = false;
    record.Scan_Total = record.Scan_Quantity * record.ScanUnit_Price;
    record.ScanGST = ((record.Scan_Quantity * record.ScanUnit_Price) * record.TaxRate) / 100;
    this.CalculateTotal();
  }

  successDeleteLineRecord(res: any, record: any, isbulkdelete: boolean) {
    this.spinner.hide();
    if (res.StatusCode == 0) {

      const index: number = this.qboDocumentLinesEdit.indexOf(record);
      console.log(index);
      this.qboDocumentLinesEdit.splice(index, 1);


      this.CalculateTotal();

      this.api.post('Rah/EditScanTotal', { 'DocumentID': this.documentID, 'ScanInvoiceTotal': this.editTotal }).subscribe(
        (res1: {}) => !isbulkdelete?alert('Updated Successfully'):"",
        error => !isbulkdelete?alert('Error in Update'):"");

    }

  }


  failedDeleteRecord1(res: any) {
    this.spinner.hide();
    console.log("Failed to Delete");
  }

  deleteLineRecord(record) {
    console.log(record.DocumentLineID);
    if (confirm("Are you sure want to remove this line ?")) {
      if (record.DocumentLineID == 0) {

        const index: number = this.qboDocumentLinesEdit.indexOf(record);
        console.log(index);
        this.qboDocumentLinesEdit.splice(index, 1);



      } else {
        this.loadingMessage = "Delete to Record..";
        this.spinner.show();
        this.api.post('Rah/DeleteQboDocumentLine', { 'DocumentLineID': record.DocumentLineID }).subscribe(
          (res1: {}) => this.successDeleteLineRecord(res1, record,false),
          error => this.failedDeleteRecord1(<any>error));
      }
    }

  }

  i : number =0; 
  deleteLineItemServiceCall(element: any, isbulkdelete: boolean)
  {
  
    console.log("***************deleteLineItemServiceCall****************"+this.i+1);
    this.api.post('Rah/DeleteQboDocumentLine', { 'DocumentLineID': element.DocumentLineID }).subscribe(
      (res1: {}) => this.successDeleteLineRecord(res1, element, false),
      error => this.failedDeleteRecord(<any>error));
  }
    deleteAllLineItem()
    {
      if(!this.deleteSelectedAllLine)
      {
       // return;
      }
      this.deleteSelectedAllLine = false;
      console.log(    this.qboVendorTemp.length+"***************deleteAllLineItem****************"+this.i);
      
      this.qboDocumentLineToDelete.forEach(element => {
        console.log(JSON.stringify(element));
      //  if(element.DocumentID == this.documentID)
        {
          console.log('********************deleteAllLineItem inside loop**************:'+this.i );
          this.api.post('Rah/DeleteQboDocumentLine', { 'DocumentLineID': element.DocumentLineID }).subscribe(
            (res1: {}) => this.successDeleteLineRecord(res1, element, true),
            error => this.failedDeleteRecord(<any>error));
        }
  
      });
  
      this.deleteSelectedAllLine=false;
    }
  Cancel() {
    this.index = 0;
  }

  splitDocumeneLine(record: any) {

    var addFlag = 0;
    if (record.Scan_Quantity >= 2) {
      if (record.Scan_Quantity % 2 == 0)
        addFlag = 0;
      else
        addFlag = 1;

      var Qty1 = Math.floor(record.Scan_Quantity / 2);
      var Qty2 = Qty1 + addFlag;
      record.Scan_Quantity = Qty2;
      record.Scan_Total = Qty2 * record.ScanUnit_Price;
      record.ScanInvoiceTotal = record.ScanGST + (Qty2 * record.ScanUnit_Price);
      record.ScanGST = ((Qty2 * record.ScanUnit_Price) * 10) / 100

      var index = this.qboDocumentLinesEdit.indexOf(record);
      console.log(index);
      console.log("record.DueDays:"+this.dueDate);
      console.log("record.ScanInvoiceDate:"+record.ScanInvoiceDate);
      this.documentID = record.DocumentID;
      this.invoiceDate = record.ScanInvoiceDate;
      if(record.DueDays == null || record.DueDays <1)
      {
        var tempdueDate = record.ScanInvoiceDate;
        if(record.ScanInvoiceDate!=null)
          {
            this.dueDate = tempdueDate.setDate(new Date(record.ScanInvoiceDate).getDate()+30);
          }else
          {
            this.dueDate = tempdueDate.setDate(new Date().getDate()+30);
          }

      }else{
        this.dueDate = record.DueDays;
      }
      console.log("record.DueDays4:"+this.dueDate);
      var splitedElement = {
        'DocumentID': this.qboDocumentLinesEdit[0].DocumentID,
        'DocumentLineID': 0,
        'Scan_Quantity': Qty1,
        'ScanUnit_Price': record.ScanUnit_Price,
        'ScanGST': ((Qty1 * record.ScanUnit_Price) * 10) / 100,
        'Scan_Total': Qty1 * record.ScanUnit_Price,
        'ScanInvoiceTotal': this.qboDocumentLinesEdit[0].ScanInvoiceTotal,
        'ScanDescription': record.ScanDescription,
        'QboAccountListID': record.QboAccountListID,
        'QboAccountName': record.QboAccountName,
        'QboItemListID': record.QboItemListID,
        'QboItemName': record.QboItemName,
        'QboJobID': record.QboJobID,
        'QboClassListID': record.QboClassListID,
        'ScanInvoiceDate': record.ScanInvoiceDate,
        'ScanTax': 10,
        'QboCustListID': record.QboCustListID,
        'QboCustName': record.QboCustName,
        'ScanABNNumber': record.ScanABNNumber,
        'ScanRefNumber': record.ScanRefNumber,
        'DueDays': record.DueDays,
        'Memo': record.Memo
      }

      this.qboDocumentLinesEdit.splice(index + 1, 0, splitedElement);



    }
    else {
      Swal.fire('', 'You can\'t split this element because it does not have sufficient quantity to split..', 'error');

    }

  }
  addNewLine() {

    var newRecord = this.qboDocumentLinesEdit.filter(a => a.DocumentLineID == 0 && a.ScanDescription == '' && a.Scan_Quantity == 0 && a.ScanUnit_Price == 0);
    if (newRecord.length > 0) {
      Swal.fire('', 'Please first fill all data in newly added line...', 'error');
    }

    else {
      var total = 0;
      var refNumber = '';
      var supplier = '';
      if(this.qboDocumentLinesEdit!=null && this.qboDocumentLinesEdit.length>0)
      {
        this.qboDocumentLinesEdit.push(
          {
            'DocumentID': this.documentID,
            'DocumentLineID': 0,
            'Scan_Quantity': 0,
            'ScanUnit_Price': 0.0,
            'ScanGST': 0.0,
            'Scan_Total': 0.0,
            'ScanInvoiceTotal': 0,
            'ScanDescription': "",
            'QboAccountListID': this.qboDocumentLinesEdit[0].QboAccountListID,
            'QboAccountName': this.qboDocumentLinesEdit[0].QboAccountName,
            'QboItemListID': this.qboDocumentLinesEdit[0].QboItemListID,
            'QboItemName': this.qboDocumentLinesEdit[0].QboItemName,
            'ScanInvoiceDate': this.qboDocumentLinesEdit[0].ScanInvoiceDate,
            'QboCustListID': this.qboDocumentLinesEdit[0].QboCustListID,
            'QboCustName': this.qboDocumentLinesEdit[0].QboCustName,
            'ScanABNNumber': this.qboDocumentLinesEdit[0].ScanABNNumber,
            'DueDays': this.qboDocumentLinesEdit[0].DueDays,
            'ScanRefNumber': this.qboDocumentLinesEdit[0].ScanRefNumber,
             'ScanTax': 0,
             'Memo':this.qboDocumentLinesEdit[0].Memo
  
          });
  
      }else{
        this.qboDocumentLinesEdit.push(
          {
            'DocumentID': "",
            'DocumentLineID': 0,
            'Scan_Quantity': 0,
            'ScanUnit_Price': 0.0,
            'ScanGST': 0.0,
            'Scan_Total': 0.0,
            'ScanInvoiceTotal': 0,
            'ScanDescription': "",
            'QboAccountListID': "",
            'QboAccountName': "",
            'QboItemListID': "",
            'QboItemName': "",
            'ScanInvoiceDate': new Date().toISOString(),
            'QboCustListID': "",
            'QboCustName': "",
            'ScanABNNumber': "",
            'DueDays': "5",
            'ScanRefNumber': "",
             'ScanTax': 0,
             'Memo':""
  
          });
  
      }
      console.log(this.qboDocumentLinesEdit);



    }

  }



  //#endregion


}
